/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
// Common
import "../components/kw-banner/kw-banner.js";
// Load Web components
import "../components/kw-button-languages/kw-button-languages.js";
import "../components/kw-footer/kw-footer.js";
import "../components/kw-form/kw-form.js";
import "../components/kw-header/kw-header.js";
import "../components/kw-input-file/kw-input-file.js";
import "../components/kw-title/kw-title.js";
import dataBanners from "../json/bannerContactData.json";
import contactFormData from "../json/contactFormData.json";
import countryPhoneCodes from "../json/countryPhoneCodes.json";
import "./lib/common/common.js";
// eslint-disable-next-line import/named
import { convertEmojiFlag } from "./lib/convertEmojiFlag.js";
// Dynamic change forms
// import { CommonTpl } from './pages/common.html.mjs';
import DataLanguage from "./lib/data-language.js";
import { DataProvider } from "./lib/data-provider.js";
import dataBanner from "./lib/dataBanner.js";
// Load scroll behavior to show/hide header
import "./lib/scroll/scroll.js";
/* eslint-disable-next-line */
import { ValidateForm } from "./lib/ValidateForm.js";

// CommonTpl.detectLanguage();
const { lang } = document.querySelector("html");
const language = lang;

const dataForm = DataLanguage.dataLanguage(
  contactFormData.contactFormData,
  language
);
const nameData = dataForm.config.find((field) => field.name === "name");
const emailData = dataForm.config.find((field) => field.name === "email");
const phoneData = dataForm.config.find((field) => field.name === "phone");
const organizationData = dataForm.config.find(
  (field) => field.name === "organization"
);
const linkedinData = dataForm.config.find((field) => field.name === "linkedin");
const centerData = dataForm.config.find((field) => field.name === "center");
const messageData = dataForm.config.find((field) => field.name === "message");
const attachmentData = dataForm.config.find(
  (field) => field.name === "attachment"
);
const whereData = dataForm.config.filter(
  (field) => field.group === "checkboxCountry"
);
const candidateTermsData = dataForm.config.find(
  (field) => field.name === "candidateTerms"
);
const candidateTerms2Data = dataForm.config.find(
  (field) => field.name === "candidateTerms2"
);
const companyTermsData = dataForm.config.find(
  (field) => field.name === "companyTerms"
);
const companyTerms2Data = dataForm.config.find(
  (field) => field.name === "companyTerms2"
);

const url = window.location.href;
const internship = url.includes("?internship");

function banner() {
  const bannerData = document.getElementById("banner-contact");
  bannerData.innerHTML = `
          <kw-banner id="Banner" banner-size="contact"  animation-type="slide-toleft" change-interval="8" >
              ${DataLanguage.dataLanguage(dataBanners.bannerContactData, lang)
                .map(dataBanner.banner)
                .join("")}
          </kw-banner>
    `;
}
function drawCheckButtonsHiden(dataCheckbox, name) {
  const radio = dataCheckbox
    .map(
      (check) => /* html */ `
            <label class="checkbox__field-label" id="label-${check.name}" for="${check.name}">${check.label}
              <input id="${check.name}" class="checkbox__input" type="checkbox" inputgroup="checkbox-group" name="${name}" value="${check.name}"/>
              <span  id="span-${name}"  name="${name}" class="checkbox__input--span" type="checkbox" ></span>
            </label>`
    )
    .join("");

  return radio;
}
function drawCheckButtons(dataCheckbox, name) {
  const radio = dataCheckbox
    .map(
      (check) => `
            <label class="checkbox__field-label" for="${check.name}">${check.label}
              <input id="${check.name}" class="checkbox__input" type="radio" inputgroup="checkbox-group" name="radio" value="${check.name}"/>
              <span  id="span-${name}"  name="${name}" class="checkbox__input--span" type="checkbox" ></span>
            </label>`
    )
    .join("");
  return radio;
}

function renderOptions(event) {
  /* eslint-disable */
  const options = event
    .map((countryCode) => {
      return /* html */ `
          <option id="${countryCode.id}" value="${
        countryCode.code
      }" selected="${countryCode.code}" >
            ${convertEmojiFlag(countryCode.flag)} ${countryCode.code}
          </option>`;
    })
    .join("");

  return options;
}

//Render dynamic forms
function renderCompanyForm() {
  return /* html */ `
    <form id="formContactCompany" action="submit" method="POST" role="form" enctype="multipart/form-data" data-validate="true" data-checkrealtime="true">
        <div class="warning warning--error warning--hidden" style="visibility: hidden;">
                <img class="warning__img--error" src="/assets/images/icon-error.svg" alt="Error icon" />
            <span class="warning__text">${dataForm.errortext} </span>
                <button class="warning__button--close"  type="button">
                    <img class="warning__img--close" src="/assets/images/ico_close_black.svg" alt="Close" />
                </button>
        </div>
        <div class="form__inputs-container">
            <div class="form___name-container">
                <label class="input__field-label" for="${
                  nameData.name
                }" aria-label="${nameData.name}">${nameData.label}</label>
                <input id="${nameData.name}"  class="input__input" name="${
    nameData.name
  }" type="${
    nameData.name
  }"  data-required="true" data-tovalidate="alfa" maxlength="50" data-val-Wrong="${
    dataForm.errorMessages.errorName
  }" data-out-Blur="${dataForm.blurMessages.blurDataRequired}" />
            </div>
            <div class="form___email-container left-column__grid-container">
                <div>
                    <label class="input__field-label" for="${
                      organizationData.name
                    }" aria-label="${organizationData.name}">${
    organizationData.label
  }</label>
                    <input id="${
                      organizationData.name
                    }"  class="input__input" name="${
    organizationData.name
  }" type="${
    organizationData.name
  }"   data-required="true" data-tovalidate="alfa" maxlength="50" data-val-Wrong="${
    dataForm.errorMessages.errorDataRequired
  }"  data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
                </div>
                <div>
                    <label class="input__field-label" for="${
                      emailData.name
                    }" aria-label="${emailData.name}">${emailData.label}</label>
                    <input id="${emailData.name}"  class="input__input" name="${
    emailData.name
  }" type="${
    emailData.name
  }"  data-required="true" data-tovalidate="email" maxlength="50" data-val-Wrong="${
    dataForm.errorMessages.errorEmail
  }" data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
                </div>
            </div>
            <div class="form___phone-container">
                <label class="input__field-label" for="${
                  phoneData.name
                }" aria-label="${phoneData.name}" >${
    phoneData.label
  }<span class="red-start">*</span></label>
                    <div id="div_input_phone" data-name="${
                      phoneData.name
                    }" class="input-phone__inputs-container">
                        <select class="input-phone__select" id="${
                          phoneData.name
                        }-country-code" aria-label="phoneCode" >
                            ${renderOptions(countryPhoneCodes)}
                        </select>
                        <input class="input-phone__input " id="${
                          phoneData.name
                        }"  value="${phoneData.value || ""}" type="${
    phoneData.type || "tel"
  }" name="${
    phoneData.name
  }"  maxlength="9" data-required="true" data-tovalidate="number" data-val-Wrong="${
    dataForm.errorMessages.errorPhone
  }"  data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
                    </div>
            </div>
            <div class="form___textarea-container">
                <label class="textarea__field-label" for="${
                  messageData.name
                }" aria-label="${messageData.name}" >${
    messageData.label
  } </label>
                <textarea class="textarea__input" id="${
                  messageData.name
                }" value="${messageData.value || ""}" type="${
    messageData.type || "textarea"
  }" name="${
    messageData.name
  }"  maxlength="350" data-required="true" data-tovalidate="textArea" data-val-Wrong="${
    dataForm.errorMessages.errorDataRequired
  }"  data-out-Blur="${dataForm.blurMessages.blurDataRequired}"></textarea>
            </div>
            <div class="form___country-container">
                <label class="input__field-label" >${
                  dataForm.checkboxTitle
                }</label>
                    <div  id="geo" class="checkbox__container" data-name="geo" data-type="checkbox-group" data-max="3" data-min="1"
                    data-error-msg="${dataForm.errorMessages.errorLocation}">
                        ${drawCheckButtons(whereData, "geo")}
                    </div>
            </div>
            <div class="form___file-container">
                <div id="file" >
                    <kw-input-file
                            id="kw-input-file-attachment"
                            attachmentLabel="${attachmentData.labelCompany}"
                            attachmentName="${attachmentData.name}"
                            maxFile="${dataForm.maxFile}"
                            maxFileMessage = "${dataForm.maxFileMessage}"
                    ></kw-input-file>
                </div>
            </div>
            <div class="form__bottom">
              <label class="checkbox__field-label" for="checkbox-${
                companyTermsData.name
              }" aria-label="${companyTermsData.name}">${companyTermsData.label}
                <input  id="checkbox-${
                  companyTermsData.name
                }" class="checkbox__input" type="checkbox" name="${
    companyTermsData.name
  }"data-required="true" data-message="${dataForm.errorMessages.errorTerms}"/>
                <span  id="span-${companyTermsData.name}" name="${
    companyTermsData.name
  }" class="checkbox__input--span" type="checkbox" /></span>
              </label>
              <label class="checkbox__field-label" for="checkbox-${
                companyTerms2Data.name
              }" aria-label="${companyTerms2Data.name}">${
    companyTerms2Data.label
  }
                <input  id="checkbox-${
                  companyTerms2Data.name
                }" class="checkbox__input" type="checkbox" name="${
    companyTerms2Data.name
  }"data-required="true" data-message="${dataForm.errorMessages.errorTerms}"/>
                <span  id="span-${companyTerms2Data.name}" name="${
    companyTerms2Data.name
  }" class="checkbox__input--span" type="checkbox" /></span>
              </label>
            </div>
        </div>
    <div class="form__button-wrapper">
        <button id="submitBtn" name="Company" class="button button--raised  button-submit--state-0" type="submit" aria-label="Enviar" data-checkform="true">
            <span class="button-submit__span button-submit__span--init-state">${
              dataForm.submit
            }</span>
            <span class="button-submit__span button-submit__span--loading-state button-submit__span--hide">
                <img width="132" height="133" src="./../assets/images/loader.gif" />
            </span>
        </button>
    </div>
</form>
  `;
}

function renderApplicantForm() {
  return /* html */ `
    <form id="formContactApplicant" action="submit" method="POST" role="form" enctype="multipart/form-data" data-validate="true" data-checkrealtime="true">
        <div  class="warning warning--error warning--hidden" style="visibility: hidden;">
            <img class="warning__img--error" src="/assets/images/icon-error.svg" alt="Error icon" />
            <span class="warning__text">${dataForm.errortext}</span>
            <button id="warning__button" class="warning__button--close"  type="button">
                <img class="warning__img--close" src="/assets/images/ico_close_black.svg" alt="Close" />
            </button>
        </div>
        <div class="form__inputs-container">
            <div class="form___name-container--applicant">
                <label class="input__field-label" for="${
                  nameData.name
                }" aria-label="${nameData.name}">${nameData.label}</label>
                <input id="${nameData.name}"  class="input__input" name="${
    nameData.name
  }" type="${
    nameData.name
  }"  data-required="true" data-tovalidate="alfa" maxlength="50"
                data-val-Wrong="${
                  dataForm.errorMessages.errorName
                }" data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
            </div>
            <div class="form___email-container--applicant">
                <label class="input__field-label" for="${
                  emailData.name
                }" aria-label="${emailData.name}">${emailData.label}</label>
                <input id="${emailData.name}"  class="input__input" name="${
    emailData.name
  }" type="${
    emailData.name
  }"  data-required="true" data-tovalidate="email" maxlength="50" data-val-Wrong="${
    dataForm.errorMessages.errorEmail
  }" data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
            </div>
            <div class="form___phone-container--applicant">
                <label class="input__field-label" for="${
                  phoneData.name
                }" aria-label="${phoneData.name}">${
    phoneData.label
  }<span class="red-start">*</span></label>
                <div id="div_input_phone" data-name="${
                  phoneData.name
                }" class="input-phone__inputs-container form-applicant">
                    <select class="input-phone__select" id="${
                      phoneData.name
                    }-country-code" aria-label="phoneCode">
                        ${renderOptions(countryPhoneCodes)}
                    </select>
                    <input class="input-phone__input " id="${
                      phoneData.name
                    }" value="${phoneData.value || ""}"  type="${
    phoneData.type || "tel"
  }" name="${
    phoneData.name
  }"  maxlength="9" data-required="true" data-tovalidate="number" data-val-Wrong="${
    dataForm.errorMessages.errorPhone
  }" data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
                </div>
            </div>
            <div class="form___linkedin-container--applicant">
                <label class="input__field-label" for="${
                  linkedinData.name
                }" aria-label="${linkedinData.name}">${
    linkedinData.label
  }</label>
                <input id="${linkedinData.name}"  class="input__input" name="${
    linkedinData.name
  }" type="${
    linkedinData.name
  }"   data-required="true" data-tovalidate="url" data-val-Wrong="${
    dataForm.errorMessages.errorLinkedin
  }" data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
            </div>
            <div class="form___textarea-container--applicant">
                <label class="textarea__field-label" for="${
                  messageData.name
                }" aria-label="${messageData.name}" >${
    messageData.label
  } </label>
                <textarea class="textarea__input" id="${
                  messageData.name
                }" value="${messageData.value || ""}" type="${
    messageData.type || "textarea"
  }" name="${
    messageData.name
  }"  maxlength="350" data-required="true" data-tovalidate="textArea" data-val-Wrong="${
    dataForm.errorMessages.errorDataRequired
  }"  data-out-Blur="${dataForm.blurMessages.blurDataRequired}"></textarea>
            </div>
            <div class="form___country-container--applicant">
                <label class="input__field-label" >${
                  dataForm.checkboxTitle
                }</label>
                <div  id="geo" class="checkbox__container" data-name="geo" data-type="checkbox-group" data-max="3" data-min="1"
                    data-error-msg="${dataForm.errorMessages.errorLocation}">
                    ${drawCheckButtons(whereData, "geo")}
                </div>
            </div>
            <div class="form___file-container ">
                <div id="file" class="form___file-container--applicant">
                    <kw-input-file
                            id="kw-input-file-attachment"
                            attachmentLabel="${attachmentData.label}"
                            attachmentName="${attachmentData.name}"
                            maxFile="${dataForm.maxFile}"
                            maxFileMessage = "${dataForm.maxFileMessage}"
                    ></kw-input-file>
                </div>
            </div>
            <div class="form__bottom">
                <label class="checkbox__field-label" for="checkbox-${
                  candidateTermsData.name
                }" aria-label="${candidateTermsData.name}">
                        ${candidateTermsData.label}
                        <input  id="checkbox-${
                          candidateTermsData.name
                        }" class="checkbox__input" type="checkbox" name="${
    candidateTermsData.name
  }"data-required="true" data-message="${dataForm.errorMessages.errorTerms}"/>
                        <span  id="span-${candidateTermsData.name}" name="${
    candidateTermsData.name
  }" class="checkbox__input--span" type="checkbox" /></span>
                </label>
                <label class="checkbox__field-label" for="checkbox-${
                  candidateTerms2Data.name
                }" aria-label="${candidateTerms2Data.name}">
                        ${candidateTerms2Data.label}
                        <input  id="checkbox-${
                          candidateTerms2Data.name
                        }" class="checkbox__input" type="checkbox" name="${
    candidateTerms2Data.name
  }"data-required="true" data-message="${dataForm.errorMessages.errorTerms}"/>
                        <span  id="span-${candidateTerms2Data.name}" name="${
    candidateTerms2Data.name
  }" class="checkbox__input--span" type="checkbox" /></span>
                </label>
            </div>
        </div>
        <div class="form__button-wrapper">
            <button id="submitBtn" name="Applicant" class="button button--raised  button-submit--state-0" type="submit" aria-label="Enviar" data-checkform="true">
            <span class="button-submit__span button-submit__span--init-state">${
              dataForm.submit
            }</span>
            <span class="button-submit__span button-submit__span--loading-state button-submit__span--hide">
                <img width="132" height="133" src="./../assets/images/loader.gif" />
            </span>
        </button>
        </div>
    </form>
    `;
}

function renderApplicantInternshipForm() {
  return /* html */ `
    <form id="formContactInternshipApplicant" action="submit" method="POST" role="form" enctype="multipart/form-data" data-validate="true" data-checkrealtime="true">
      <div class="form__inputs-container">
        <div class="form___name-container--applicant">
          <label class="input__field-label" for="${
            nameData.name
          }" aria-label="${nameData.name}">${nameData.label}</label>
          <input
            id="${nameData.name}"
            class="input__input"
            name="${nameData.name}"
            type="${nameData.name}"
            data-required="true"
            data-tovalidate="alfa"
            maxlength="50"
            data-val-Wrong="${dataForm.errorMessages.errorName}"
            data-out-Blur="${dataForm.blurMessages.blurDataRequired}"
          />
        </div>
        <div class="form___email-container--applicant">
          <label class="input__field-label" for="${
            emailData.name
          }" aria-label="${emailData.name}">${emailData.label}</label>
          <input
            id="${emailData.name}"
            class="input__input"
            name="${emailData.name}"
            type="${emailData.name}"
            data-required="true"
            data-tovalidate="email"
            maxlength="50"
            data-val-Wrong="${dataForm.errorMessages.errorEmail}"
            data-out-Blur="${dataForm.blurMessages.blurDataRequired}"/>
        </div>
        <div class="form___phone-container--applicant">
          <label class="input__field-label" for="${
            phoneData.name
          }" aria-label="${phoneData.name}">${
    phoneData.label
  }<span class="red-start">*</span></label>
          <div id="div_input_phone" data-name="${
            phoneData.name
          }" class="input-phone__inputs-container form-applicant">
            <select class="input-phone__select" id="${
              phoneData.name
            }-country-code" aria-label="phoneCode">
              ${renderOptions(countryPhoneCodes)}
            </select>
            <input
              class="input-phone__input"
              id="${phoneData.name}"
              value="${phoneData.value || ""}"
              type="${phoneData.type || "tel"}"
              name="${phoneData.name}"
              maxlength="9"
              data-required="true"
              data-tovalidate="number"
              data-val-Wrong="${dataForm.errorMessages.errorPhone}"
              data-out-Blur="${dataForm.blurMessages.blurDataRequired}"
            />
          </div>
        </div>
        <div class="form___country-container--applicant-internship">
          <label class="input__field-label" >${dataForm.checkboxTitle}</label>
          <div  id="geo" class="checkbox__container" data-name="geo" data-type="checkbox-group" data-max="3" data-min="1" data-required="true"
              data-error-msg="${dataForm.errorMessages.errorLocation}">
              ${drawCheckButtonsHiden(whereData, "geo")}
          </div>
        </div>
        <div class="form___linkedin-container--applicant">
          <label class="input__field-label" for="${
            linkedinData.name
          }" aria-label="${linkedinData.name}">${linkedinData.label}</label>
          <input
            id="${linkedinData.name}"
            class="input__input" name="${linkedinData.name}"
            type="${linkedinData.name}"
          />
        </div>
        <div class="form___center-container--applicant-internship">
          <label class="input__field-label" for="${
            centerData.name
          }" aria-label="${centerData.name}">${centerData.label}</label>
            <input
              id="${centerData.name}"
              class="input-phone__input"
              name="${centerData.name}"
              type="${centerData.name}"
              data-required="true"
              data-val-Wrong="${dataForm.errorMessages.errorRequiredCenter}"
              data-out-Blur="${dataForm.blurMessages.blurDataRequired}"
            />
        </div>
        <div class="form___file-container--applicant-internship">
        <div id="file">
          <kw-input-file
            id="kw-input-file-attachment"
            attachmentLabel="${attachmentData.label}"
            attachmentName="${attachmentData.name}"
            maxFile="${dataForm.maxFile}"
            maxFileMessage = "${dataForm.maxFileMessage}"
          ></kw-input-file>
        </div>
      </div>
      <div class="form___textarea-container--applicant">
        <label class="textarea__field-label" for="${
          messageData.name
        }" aria-label="${messageData.name}">${messageData.label}</label>
        <textarea
          class="textarea__input"
          id="${messageData.name}"
          value="${messageData.value || ""}"
          type="${messageData.type || "textarea"}"
          name="${messageData.name}"
          maxlength="350"
          data-required="true"
          data-tovalidate="textArea"
          data-val-Wrong="${dataForm.errorMessages.errorDataRequired}"
          data-out-Blur="${dataForm.blurMessages.blurDataRequired}">""
        </textarea>
      </div>
      <div class="form__bottom">
      <label class="checkbox__field-label" for="checkbox-${
        companyTermsData.name
      }" aria-label="${companyTermsData.name}">${companyTermsData.label}
        <input  id="checkbox-${
          companyTermsData.name
        }" class="checkbox__input" type="checkbox" name="${
    companyTermsData.name
  }"data-required="true" data-message="${dataForm.errorMessages.errorTerms}"/>
        <span  id="span-${companyTermsData.name}" name="${
    companyTermsData.name
  }" class="checkbox__input--span" type="checkbox" /></span>
      </label>
      <label class="checkbox__field-label" for="checkbox-${
        companyTerms2Data.name
      }" aria-label="${companyTerms2Data.name}">${companyTerms2Data.label}
        <input  id="checkbox-${
          companyTerms2Data.name
        }" class="checkbox__input" type="checkbox" name="${
    companyTerms2Data.name
  }"data-required="true" data-message="${dataForm.errorMessages.errorTerms}"/>
        <span  id="span-${companyTerms2Data.name}" name="${
    companyTerms2Data.name
  }" class="checkbox__input--span" type="checkbox" /></span>
      </label>
    </div>
      </div>
      </div>
      <div class="warning warning--error warning--hidden">
        <img class="warning__img--error" src="/assets/images/icon-error.svg" alt="Error icon" />
        <span class="warning__text">${dataForm.errortext}</span>
        <button id="warning__button" class="warning__button--close" type="button">
          <img class="warning__img--close" src="/assets/images/ico_close_black.svg" alt="Close" />
        </button>
      </div>
      <div class="warning warning--error warning--hidden warning--linkedin-or-resume">
         <img class="warning__img--error" src="/assets/images/icon-error.svg" alt="Error icon" />
         <span class="warning__text">${
           dataForm.errorMessages.errorLinkedinOrCV
         } </span>
      </div>
      <div class="form__button-wrapper">
        <button id="submitBtn" name="Applicant" class="button button--raised  button-submit--state-0" type="submit" aria-label="Enviar" data-checkform="true">
        <span class="button-submit__span button-submit__span--init-state">${
          dataForm.submit
        }</span>
        <span class="button-submit__span button-submit__span--loading-state button-submit__span--hide">
          <img width="132" height="133" src="./../assets/images/loader.gif" />
        </span>
        </button>
      </div>
    </form>
    `;
}

function renderSelectButtons() {
  return /* html */ `
    <div>
        <span>${dataForm.titleForm.company.subTitle}</span>
        <div class="contact-form__container-button" >
        <button aria-selected= "true" class="contact-form__button" id="companyButton" type="button" aria-label= "${dataForm.selectButtons.company.ariaLabel}">${dataForm.selectButtons.company.text}</button>
        <button aria-selected= "false" class="contact-form__button" id="applicantButton" type="button" aria-label= "${dataForm.selectButtons.applicant.ariaLabel}">${dataForm.selectButtons.applicant.text}</button>
        </div>
    </div>
    `;
}

function addNewLineTextTitle(stringTitle) {
  if (window.innerWidth < 760) {
    return stringTitle.replace("\n\n", "<br>");
  } else {
    return stringTitle;
  }
}

function changeFormSelected(event) {
  const inputsContainer = document.querySelector("#inputsFormContainer");
  const buttonCompany = document.querySelector("#companyButton");
  const buttonApplicant = document.querySelector("#applicantButton");
  const imageDecorationForm = document.querySelector("#contactImageDecoration");
  const titleForm = document.querySelector("#formTitle");

  if (event.target.id === "companyButton") {
    buttonCompany.setAttribute("aria-selected", "true");
    buttonApplicant.setAttribute("aria-selected", "false");
    imageDecorationForm.setAttribute(
      "src",
      `${
        window.innerWidth < 760
          ? dataForm.imageForm.company.srcImageMobile
          : dataForm.imageForm.company.srcImageDesktop
      }`
    );
    imageDecorationForm.parentElement.classList.remove("changePosition");
    titleForm.innerHTML = `${addNewLineTextTitle(
      dataForm.titleForm.company.title
    )}`;
    inputsContainer.innerHTML = `${renderCompanyForm()}`;
    const validador = new ValidateForm();
    document.addEventListener("submit-clicked", dataSuccess);
  }
  if (event.target.id === "applicantButton") {
    buttonCompany.setAttribute("aria-selected", "false");
    buttonApplicant.setAttribute("aria-selected", "true");
    imageDecorationForm.setAttribute(
      "src",
      `${
        window.innerWidth < 760
          ? dataForm.imageForm.applicant.srcImageMobile
          : dataForm.imageForm.applicant.srcImageDesktop
      }`
    );
    imageDecorationForm.parentElement.classList.add("changePosition");
    titleForm.innerHTML = `${addNewLineTextTitle(
      dataForm.titleForm.applicant.title
    )}`;
    inputsContainer.innerHTML = `${renderApplicantForm()}`;
    const validador = new ValidateForm();
    document.addEventListener("submit-clicked", dataSuccess);
  }
}

function handleButtonSelection() {
  const buttonCompany = document.querySelector("#companyButton");
  const buttonApplicant = document.querySelector("#applicantButton");
  try {
    buttonApplicant.addEventListener("click", changeFormSelected);
    buttonCompany.addEventListener("click", changeFormSelected);
  } catch (error) {
    console.log(error);
  }
}

/* Logic of Submit the form */

const CAPTCHA_KEY = "6LesHdMUAAAAACrxUvPXMxa94GWuj9HKumYYpTW7";
let data = {};
const fieldsDataFormated = {};

function dataGeography() {
  const spain = document.getElementById("spain").checked;
  const mexico = document.getElementById("mexico").checked;
  const peru = document.getElementById("peru").checked;
  const asia = document.getElementById("asia").checked;

  let countryChecked = [];
  if (spain) {
    countryChecked = ["es", ...countryChecked];
  }
  if (mexico) {
    countryChecked = [...countryChecked, "mx"];
  }
  if (peru) {
    countryChecked = [...countryChecked, "pe"];
  }
  if (asia) {
    countryChecked = [...countryChecked, "sg"];
  }
  const countryCheckedToString = countryChecked.toLocaleString();
  fieldsDataFormated.geo = countryCheckedToString;

  return fieldsDataFormated.geo;
}

async function handleSubmit() {
  try {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6LesHdMUAAAAACrxUvPXMxa94GWuj9HKumYYpTW7";
    script.defer = true;
    document.body.appendChild(script);

    const lang = language;
    let data = new FormData(document.querySelector("form"));
    for (let [key, value] of data.entries()) {
      fieldsDataFormated[key] = value;
    }

    dataGeography();

    fieldsDataFormated.phone = `${
      document.getElementById("phone-country-code").value
    } ${fieldsDataFormated.phone}`;

    const attachment = document
      .getElementById("kw-input-file-attachment")
      .shadowRoot.querySelector('input[name="attachment"]');

    const dataFile = attachment.value || null;

    dataFile === null
      ? (fieldsDataFormated.attachment = undefined)
      : (fieldsDataFormated.attachment = JSON.parse(attachment.value).data);

    if (internship && !fieldsDataFormated.linkedin && !dataFile) {
      const warningError = document.querySelector(
        ".warning--linkedin-or-resume"
      );
      warningError.classList.remove("warning--hidden");
      throw new Error("Linkedin and/or PDF please");
    }

    const token = await grecaptcha.execute(CAPTCHA_KEY);
    let offer = "";

    if (internship) {
      offer = "Internship";
    } else {
      offer = document.getElementById("submitBtn").getAttribute("name");
    }

    fieldsDataFormated.offer = offer;

    if (internship && fieldsDataFormated.center !== "") {
      fieldsDataFormated.organization = fieldsDataFormated.center;
    }

    const dataSend = {
      ...fieldsDataFormated,
      lang,
      token,
      offer,
    };

    return dataSend;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Something went wrong: ${error}`);
  }
}

async function dataSuccess() {
  try {
    data = await handleSubmit();
    if (!data) throw new Error("There is no data to send");
    else {
      btnAnimation();
      sendEmail();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      `Something went wrong trying to get fields data to send: ${error}`
    );
    // TODO: Handle generic errors
  }
}

function sendEmail() {
  let {
    attachment,
    email,
    geo,
    linkedin,
    message,
    name,
    offer,
    organization,
    phone,
    terms,
    lang,
    token,
  } = data;
  if (
    data.hasOwnProperty("companyTerms") &&
    data.hasOwnProperty("companyTerms2")
  ) {
    terms = "on";
  }
  if (data.hasOwnProperty("candidateTerms")) {
    terms = "on";
  }
  if (linkedin === null || linkedin === undefined) {
    linkedin = "";
  }
  const mailData = {
    attachment,
    country: geo,
    email,
    name,
    linkedin,
    text: message,
    who: organization || linkedin,
    phone,
    subject: offer,
    terms: terms === "on" ? true : null,
    token,
    lang,
  };

  const emailType =
    offer === "Company" || offer === "Applicant" || offer === "Internship"
      ? "CONTACT"
      : "JOBOFFER";
  let dataProvider = new DataProvider();

  dataProvider
    .post(`send?emailType=${emailType}`, JSON.stringify(mailData))
    .then(() => {
      clearForm();
      renderSuccesView(offer);
      dataProvider = "";
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.warn(`Error sending the email: ${error}`);
    });
}

function clearForm() {
  document.querySelector("form").reset();
}

function btnAnimation() {
  const button = document.querySelector("#submitBtn");

  return new Promise((resolve) => {
    // Listener for ending transitions
    button.addEventListener("transitionend", () => {
      resolve();
    });

    button.classList.remove("button--raised");
    button.classList.add("button--submit");
    button.classList.add("button-submit--state-1");
    setTimeout(() => {
      button.children[0].classList.add("button-submit__span--hide");
      button.children[1].classList.remove("button-submit__span--hide");
    }, 500);
  });
}

function paperPlaneImageMobile() {
  return /* html */ `
  <img width="178" height="138" class="img-check" id="contactImageDecoration"
      src="${dataForm.imageForm.company.srcImageMobile}"
      alt="${dataForm.imageForm.company.altImage}"/>
  `;
}

function paperPlaneImageDesktop() {
  return /* html */ `
  <img width="478" height="305" class="img-check" id="contactImageDecoration"
      src="${dataForm.imageForm.company.srcImageDesktop}"
      alt="${dataForm.imageForm.company.altImage}"/>
  `;
}

function bulbImageMobile() {
  return /* html */ `
  <img width="178" height="138" class="img-check" id="contactImageDecoration"
      src="${dataForm.imageForm.internship.srcImageMobile}"
      alt="${dataForm.imageForm.internship.altImage}"/>
  `;
}

function bulbImageDesktop() {
  return /* html */ `
  <img width="478" height="200" class="img-check" id="contactImageDecoration"
      src="${dataForm.imageForm.internship.srcImageDesktop}"
      alt="${dataForm.imageForm.internship.altImage}"/>
  `;
}

/*----------------------------*/
function renderForm() {
  const formContainer = document.querySelector("#formContainer");
  if (internship) {
    formContainer.innerHTML = /* html */ `
      <div class="container contact__container">
          <div class="contact__image-decoration--container">
                ${
                  window.innerWidth < 760
                    ? bulbImageMobile()
                    : bulbImageDesktop()
                }
              </div>
              <h3 id="formTitle" class="contact-form__title">${addNewLineTextTitle(
                dataForm.titleForm.internship.title
              )}</h3>
              <div id="inputsFormContainer" class="marginFormContainer">
                  ${renderApplicantInternshipForm()}
          </div>
      </div>
  `;
    document.querySelector("#spain").setAttribute("checked", "true");
    document.querySelector("#label-mexico").style.display = "none";
    document.querySelector("#label-peru").style.display = "none";
    document.querySelector("#label-asia").style.display = "none";
    document.querySelector("#message").innerHTML = "";
  } else {
    formContainer.innerHTML = /* html */ `
      <div class="container contact__container">
          <div class="contact__image-decoration--container">
                ${
                  window.innerWidth < 760
                    ? paperPlaneImageMobile()
                    : paperPlaneImageDesktop()
                }
              </div>
              <h3 id="formTitle" class="contact-form__title">${addNewLineTextTitle(
                dataForm.titleForm.company.title
              )}</h3>
                  ${renderSelectButtons()}
              <div id="inputsFormContainer" class="marginFormContainer">
                  ${renderCompanyForm()}
          </div>
      </div>
    `;
    handleButtonSelection();
  }

  document.addEventListener("submit-clicked", dataSuccess);
}

function renderSuccesView(e) {
  const formContainer = document.querySelector("#formContainer");
  formContainer.innerHTML = /* html */ `
        <div class=" form__success-container" >
            <div>
                <img id="check-success" src="${
                  dataForm.imageForm.succesForm.srcImageCheck
                }" alt="${dataForm.imageForm.succesForm.srcImageCheck}"/>
            </div>
            <div class="form__success-block">
                <h3 id="formTitleSuccess">${dataForm.sentText}</h3>
                <p id="formTextSucccess" class="form__success_text">${
                  dataForm.success
                }</p>
                <p id="formTestQuestion" class="form__success-text-strong">${
                  dataForm.question
                }</p>
                <div class="form__link-wrapper">
                    <a
                        class="link link--raised link--text-large""
                        target="_self"
                        href="${
                          e === "Company"
                            ? `/${lang}/about-us.html`
                            : e === "Applicant"
                            ? `/${lang}/join-us.html`
                            : `/${lang}/join-us.html`
                        }"
                        theme="raised">
                        ${
                          e === "Company"
                            ? dataForm.redirectButtonCompany
                            : e === "Applicant"
                            ? dataForm.redirectButtonApplicant
                            : dataForm.redirectButtonApplicant
                        }
                    </a>
                </div>
            </div>
        </div>
        `;
}

function handleLoadWindowFunctions() {
  banner();
  renderForm();
}

if (document.addEventListener) {
  window.addEventListener("load", handleLoadWindowFunctions);
  const script = document.createElement("script");
  script.src =
    "https://www.google.com/recaptcha/api.js?render=6LesHdMUAAAAACrxUvPXMxa94GWuj9HKumYYpTW7";
  script.defer = true;
  document.body.appendChild(script);
}
